module.exports = __webpack_public_path__ + "img/shape_rectangle--blue.e4c9bd1.webp";